import { FC } from 'react';

import { Tab, Tabs } from '@beeline/design-system-react/extracted-styles';

import { TabsProvider, useTabs } from './TabsProvider';

const Inner: FC = () => {
  const { selectedTabIndex, selectTabIndex, tabItems } = useTabs();

  return (
    <Tabs selectedTabIndex={selectedTabIndex} onChange={selectTabIndex}>
      {tabItems.map(tabItem => (
        <Tab key={tabItem.path} label={tabItem.label} />
      ))}
    </Tabs>
  );
};

export const AppTabs: FC = () => {
  return (
    <TabsProvider>
      <Inner />
    </TabsProvider>
  );
};
